//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentColliDetail', {
//        templateUrl: 'views/components/views/consignmentColliDetail/consignmentColliDetail.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'consignmentColliDetailService', 'ttGridFactory', 'translateService', 'layoutService', function ($stateParams, stateService, utilityService, modalService, consignmentColliDetailService, ttGridFactory, translateService, layoutService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let consignmentColliKeyno = $stateParams.consignmentcolli_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                tabletSize: layoutService.getMediaQueries().tablet,
//                gridReady: false,
//                bgConsignmentColliDetail: {
//                    selected: 'BASIS',
//                    buttons: [
//                        { id: 'BASIS', label: 'bg_consignmentcollidetail_basis', color: 'primary', onClick: () => vm.model.bgConsignmentColliDetail.selected = 'BASIS' },
//                        { id: 'CONTENT', label: 'bg_consignmentcollidetail_content', color: 'primary', onClick: () => vm.model.bgConsignmentColliDetail.selected = 'CONTENT' }
//                    ]
//                },
//                caseKeynoButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('case', { case_keyno: vm.model.edit.case_keyno }) }
//                ],
//                edit: {},
//                itemsListDetails: [],
//                lockedSave: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_consignmentcollidetail_carriers_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await consignmentColliDetailService.getEdit({ consignmentcolli_keyno: consignmentColliKeyno }))[0];
//            }

//            async function loadDetails() {
//                if (utilityService.validateParmsValue(vm.model.edit.consignmentcolli_keyno) !== true) return;

//                vm.model.itemsListDetails = await consignmentColliDetailService.listDetails({ consignmentcolli_keyno: vm.model.edit.consignmentcolli_keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 2668,
//                    parameters: vm.model.edit
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgConsignmentColliDetail = function (value) {
//                vm.model.bgConsignmentColliDetail.selected = value;
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region ON CHANGE FUNCTION

//            vm.onChanged = function (value, field) {
//                switch (field) {
//                    case 'length': { vm.model.edit.length = value; recalcVolume(); break; }
//                    case 'width': { vm.model.edit.width = value; recalcVolume(); break; }
//                    case 'height': { vm.model.edit.height = value; recalcVolume(); break; }
//                    default: break;
//                }
//            }

//            // #endregion ON CHANGE FUNCTION

//            // #region RECALCULATION FUNCTION

//            function recalcVolume() {
//                vm.model.edit.volume = vm.model.edit.length * vm.model.edit.width * vm.model.edit.height / 1000000; // Volum i m3
//            }

//            // #endregion RECALCULATION FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                let allData = vm.grid.gridfunc.getAllRows();
//                let currentData = [];
//                let mergeObj = vm.model.edit;

//                allData.forEach((item) => {
//                    currentData.push({
//                        carrier_keyno: item.carrier_keyno,
//                        quantity: item.quantity,
//                        consignmentcarrier_keyno: item.consignmentcarrier_keyno
//                    });
//                }); 

//                mergeObj.records = currentData;

//                consignmentColliDetailService.saveObj(mergeObj).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.go('consignment', { consignment_keyno: vm.model.edit.consignment_keyno });
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadDetails();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
